import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TenantService } from '../services/tenant.service';

/**
 * Guards routes that assume a tenant/company context has already been resolved (see
 * `TenantService.tenant()`). Without it, a route reached directly — e.g. a bookmarked or
 * shared deep link straight to `/login`, bypassing `LaunchPage`'s URL resolution entirely —
 * would render with no tenant at all (empty Warehouse block, no Change link).
 *
 * Redirects to `/launch` when there is none, which re-resolves the current URL on every
 * activation and routes appropriately from there (company -> `/tenant` picker, tenant ->
 * `/login` with context, unresolvable -> `/url-error`).
 */
export const tenantResolvedGuard: CanActivateFn = () => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  return tenantService.tenant() !== null ? true : router.createUrlTree(['/launch']);
};
